import type { FC } from 'react';
import { useMemo } from 'react';

import BingoBlackEmeraldIcon from '../../assets/JSL/Bingo_Black_Emerald.svg';
import BingoBlackRubyIcon from '../../assets/JSL/Bingo_Black_Ruby.svg';
import BingoBlackTopazIcon from '../../assets/JSL/Bingo_Black_Topaz.svg';
import BingoEmeraldIcon from '../../assets/JSL/Bingo_Emerald.svg';
import BingoLeftArrowIcon from '../../assets/JSL/Bingo_Left_Arrow.svg';
import BingoRubyIcon from '../../assets/JSL/Bingo_Ruby.svg';
import BingoTopazIcon from '../../assets/JSL/Bingo_Topaz.svg';
import BingoOtherArrowIcon from '../../assets/JSL/Other_Arrow.svg';

import styles from './JSL.module.css';

const JSL_ICONS: Record<string, string> = {
  ['Bingo Black Emerald']: BingoBlackEmeraldIcon,
  ['Bingo Black Ruby']: BingoBlackRubyIcon,
  ['Bingo Black Topaz']: BingoBlackTopazIcon,
  ['Bingo Emerald']: BingoEmeraldIcon,
  ['Bingo Left Arrow']: BingoLeftArrowIcon,
  ['Bingo Ruby']: BingoRubyIcon,
  ['Bingo Topaz']: BingoTopazIcon,
  ['Bingo Other Arrow']: BingoOtherArrowIcon,
};

const bingoCode = {
  '301': 'Bingo Topaz',
  '302': 'Bingo Emerald',
  '303': 'Bingo Ruby',
  '304': 'Bingo Black Topaz',
  '305': 'Bingo Black Emerald',
  '306': 'Bingo Black Ruby',
  '307': 'Bingo Left Arrow',
};

export const JSL: FC<{ bingoData: { code: string; points: string }[] }> = ({ bingoData = [] }) => {
  const bingoArray = useMemo(() => {
    const result: string[] = [];
    bingoData.forEach(({ code, points }) => {
      result.push(bingoCode[code as keyof typeof bingoCode]);
      const pointsNumber = parseInt(points);
      const additionalLeftArrows = !isNaN(pointsNumber) ? pointsNumber - 1 : 0;
      for (let i = 0; i < additionalLeftArrows; i++) {
        result.push(bingoCode['307']);
      }
    });
    return result;
  }, [bingoData]);

  return (
    <div className={styles.jslContainer}>
      {bingoArray.map((code, index) => (
        <img key={index} className={styles.jslBall} src={JSL_ICONS[code]} alt={code} />
      ))}
    </div>
  );
};
